import * as React from 'react';
import c from 'classnames';
import Immutable from 'immutable';
import { useTranslation } from 'react-i18next';

import { Paragraph } from '@uncinc/react-drupal-core';
import { Container } from '@uncinc/uncinc-react-kitchen-sink';
import { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import {
  DynamicMediaItem,
  Hero,
  RelatedContentByTheme,
  RelatedThemeContent,
} from '../../../../../components';
import { DEFAULT_LANGUAGE } from '../../../../../config/constants';
import { TaxonomyTheme } from '../../../../../types/uncinc_profile/taxonomy';

interface ThemeProps {
  entity: ImmutableEntity<TaxonomyTheme>;
}

const TaxonomyThemeParent: React.FC<ThemeProps> = ({ entity }) => {
  const { t } = useTranslation('translation', { keyPrefix: 'pages.taxonomy_theme_page' });

  const theme = entity.toJS();
  const id = theme.tid[0].value;
  const name = theme.name[0].value;
  const link = theme.field_link[0];

  const classes = c('TaxonomyTheme');

  return (
    <div className={classes}>
      <Hero
        title={name}
        body={theme.description[0].value || ''}
        media={<DynamicMediaItem media={theme.field_media_item[0]} imageAspectRatio="16_9" aboveTheFold />}
        containMedia={theme.field_media_item[0].bundle === 'svg'}
        background="secondary"
        button={link}
      />

      <Container>
        <div className="content-section mb-0">
          <RelatedThemeContent
            themeId={id}
            theme={theme}
          />
          {theme.field_paragraphs && (
            <div className="content-section">
              {theme.field_paragraphs.map((paragraph) => {
                const paragraphId = paragraph.target_id;
                const language = paragraph.entity?.langcode[0].value || DEFAULT_LANGUAGE;
                return (
                  <Paragraph
                    key={`paragraph:${paragraphId}:${language}`}
                    id={paragraphId}
                    entity={Immutable.fromJS(paragraph.entity)}
                  />
                );
              })}
            </div>
          )}
        </div>
      </Container>

      <RelatedContentByTheme
        themeIds={[id]}
        themeName={name}
        title={t('related_content_title', { theme: name.toLowerCase() })}
      />
    </div>
  );
};

export default TaxonomyThemeParent;
